<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">密钥信息</span>
      </div>
      <el-form ref="form" :model="form" :rules="formRules" label-width="120px" style="width: 600px;">
        <el-form-item label="机构类型" prop="orgType">
          <el-radio-group v-model="form.orgType" @change="checkOrgType">
            <el-radio :label="0">互联互通运营商</el-radio>
            <el-radio :label="1">流量方</el-radio>
            <el-radio :label="2">监管平台</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="机构名称" prop="companyId">
          <el-select v-model="form.companyId" filterable remote reserve-keyword placeholder="请输入搜索关键词" style="width:100%" :remote-method="getOrgList">
            <el-option v-for="item in orgList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="机构密钥" prop="orgKey">
          <el-input v-model="form.orgKey" placeholder="请输入机构密钥" />
        </el-form-item>
        <el-form-item label="消息密钥" prop="smsKey">
          <el-input v-model="form.smsKey" placeholder="请输入消息密钥" />
        </el-form-item>
        <el-form-item label="初始化向量" prop="initVector">
          <el-input v-model="form.initVector" placeholder="请输入初始化向量" />
        </el-form-item>
        <el-form-item label="签名密钥" prop="signKey">
          <el-input v-model="form.signKey" placeholder="请输入签名密钥" />
        </el-form-item>
        <el-form-item label="流量方接口url" prop="url">
          <el-input v-model="form.url" placeholder="请输入流量方接口url" />
        </el-form-item>
      </el-form>
      <div style="width:100%;text-align: center">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import { HOST, EV_HOST } from '@/utils/host'
export default {
  name: 'Xinzengmiyao',
  components: {},
  data() {
    return {
      form: {
        orgType: 0,
        companyId: '',
        orgKey: '',
        smsKey: '',
        initVector: '',
        signKey: '',
        url: ''
      },
      orgList: [],
      formRules: {
        orgType: [
          { required: true, message: '请选择机构名称', trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: '请选择机构名称', trigger: 'blur' }
        ],
        orgKey: [
          { required: true, message: '请输入机构密钥', trigger: 'blur' }
        ],
        smsKey: [
          { required: true, message: '请输入消息密钥', trigger: 'blur' }
        ],
        initVector: [
          { required: true, message: '请输入初始化向量', trigger: 'blur' }
        ],
        signKey: [
          { required: true, message: '请输入签名密钥', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入流量方接口url', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {},
  mounted() {
    this.getOrgList()
  },
  beforeMount() {
    this.id = this.$route.query.data
  },
  methods: {
    checkOrgType(val) {
      this.form.orgType = val
      this.orgList = []
      this.getOrgList()
    },
    getOrgList(val) {
      const data = {
        name: val
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/getOrgName',
        data: data,
        method: 'get',
        callback: resp => {
          if (resp.length > 0) {
            for (var i = 0; i < resp.length; i++) {
              if (this.form.orgType === 0) {
                if (resp[i].orgType === 0 || resp[i].orgType === 3) {
                  this.orgList.push(resp[i])
                }
              } else {
                if (resp[i].orgType === 2) {
                  this.orgList.push(resp[i])
                }
              }
            }
          }
        }
      })
    },
    cancel() {
      this.$router.go(-1)
    },
    async save() {
      try {
        // 必填校验
        await Promise.all([
          this.$refs.form.validate()
        ])
      } catch (error) {
        return
      }
      const data = this.form
      this.$store.dispatch('form/handle', {
        url: '/setting',
        data: data,
        method: 'put',
        callback: resp => {
          this.$router.go(-1)
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/addSecretKey.vue